import { getByID } from '@adornis/baseql/operations/mongo.js';
import { getLecturerDataByLecturerID } from '@adornis/buchungsheld-db/entities/lecturerData.js';
import { User } from '@adornis/buchungsheld-db/entities/user.js';
import { stateful } from '@adornis/functional-lit/stateful.js';
import { useQuery } from '@adornis/functional-lit/use-query.js';
import { html, nothing } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

export const RegistrationLecturerDetails = stateful(({ lecturerID }: { lecturerID: string }) => {
  const lecturerData = useQuery(
    () =>
      getByID(
        User,
        lecturerID,
      )({
        title: 1,
        firstName: 1,
        lastName: 1,
        email: 1,
      }),
    [lecturerID],
  );
  const lecturer = lecturerData.value;

  const specificData = useQuery(
    () =>
      getLecturerDataByLecturerID(lecturerID)({
        detailPage: 1,
      }),
    [lecturerID],
  );
  const specifics = specificData.value;

  if (!specifics || !lecturer) return html` loading oder so `;

  return html`
    <tr-flex space="md">
      <tr-h2> ${lecturer?.firstName} ${lecturer?.lastName} </tr-h2>

      <!-- buildify details -->
      ${specifics.detailPage
        ? html`
            <tr-hr></tr-hr>
            ${unsafeHTML(specifics.detailPage)}
          `
        : nothing}
    </tr-flex>
  `;
});
